"use strict";

angular.module("customer")
.controller("SectionMyOrders", function($scope, $state, $stateParams, OrderStatusService, CustomerOrderService) {
    $scope.pagination = {};
    $scope.statusNames = OrderStatusService.getStatusNamesTranslations();

    $scope.search = function() {
        var page = $scope.pagination.current_page;
        var search = $stateParams.search;

        CustomerOrderService.query(search, page).$promise.then(
            function(data) {
                $scope.pagination = data.pagination;
                $scope.Orders = data.results;
            });
    };

    $scope.seeDetails = function(id) {
        $state.go("orderDetails", {id: id});
    };

    $scope.search();

});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order/order-list.controller.js
// module id = 898
// module chunks = 0